import i18next from "i18next";
import { success, custom } from "./utilities";
import { ToastifyService, CourseService, userService } from "../../services";
import {
  studentConstants,
  globalSystemConstants,
  translationConstants,
} from "../../constants";

const gridData = {
  length: 10,
  pageNumber: 1,
  orderBy: null,
  filterQuery: null,
  search: null,
};

export const getStudentsByInstructorId = (gridData, instructorId) => {
  return (dispatch) => {
    dispatch(
      custom(
        studentConstants.GET_PAGINATION_DATA,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    CourseService.getStudentsByInstructorId(instructorId, gridData)
      .then((response) => {
        dispatch(success(response, studentConstants.GET_PAGINATION_DATA));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            studentConstants.GET_PAGINATION_DATA,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const getStatsByInstructorId = (instructorId) => {
  return (dispatch) => {
    dispatch(
      custom(studentConstants.GET_STATS, globalSystemConstants.SPINNER_ACTIVATE)
    );
    CourseService.getStatsByInstructorId(instructorId)
      .then((response) => {
        dispatch(success(response, studentConstants.GET_STATS));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            studentConstants.GET_STATS,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const addStudent = (data, isCenterAdmin = false, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(
        studentConstants.GET_PAGINATION_DATA,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    CourseService.addStudent(data)
      .then((response) => {
        if (isCenterAdmin) {
          if (onSuccess) {
            onSuccess();
          }
        } else {
          dispatch(getStudentsByInstructorId(gridData, data.instructorId));
          dispatch(getStatsByInstructorId(data.instructorId));
        }
        ToastifyService.showSuccess(i18next.t(response));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            studentConstants.GET_PAGINATION_DATA,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const getStudentByEmail = (email) => {
  return (dispatch) => {
    dispatch(
      custom(
        studentConstants.VIEW_STUDENT,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    CourseService.getStudentByEmail(email)
      .then((response) => {
        dispatch(success(response, studentConstants.VIEW_STUDENT));
      })
      .catch((error) =>
        ToastifyService.showError(translationConstants.SAILOR_NOT_FOUND)
      )
      .finally(() => {
        dispatch(
          custom(
            studentConstants.VIEW_STUDENT,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const getStudentById = (id) => {
  return (dispatch) => {
    dispatch(
      custom(
        studentConstants.GET_PAGINATION_DATA,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    CourseService.getStudentById(id)
      .then((response) => {
        dispatch(success(response, studentConstants.VIEW_STUDENT));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            studentConstants.GET_PAGINATION_DATA,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const getNonVerifiedStudentById = (id) => {
  return (dispatch) => {
    dispatch(
      custom(
        studentConstants.GET_PAGINATION_DATA,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    CourseService.getNonVerifiedStudentById(id)
      .then((response) => {
        dispatch(success(response, studentConstants.VIEW_STUDENT));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            studentConstants.GET_PAGINATION_DATA,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const initialState = () => {
  return (dispatch) => {
    dispatch(success(null, studentConstants.INITIAL_STATE));
  };
};

export const getStudentsByCenterId = (gridData, centerId) => {
  return (dispatch) => {
    dispatch(
      custom(
        studentConstants.GET_CENTER_PAGINATION_DATA,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    CourseService.getStudentsByCenterId(centerId, gridData)
      .then((response) => {
        dispatch(
          success(response, studentConstants.GET_CENTER_PAGINATION_DATA)
        );
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            studentConstants.GET_CENTER_PAGINATION_DATA,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const getAllCourses = (gridData) => {
  return (dispatch) => {
    dispatch(
      custom(
        studentConstants.GET_ALL_COURSES,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    CourseService.getAllCourses(gridData)
      .then((response) => {
        dispatch(success(response, studentConstants.GET_ALL_COURSES));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            studentConstants.GET_ALL_COURSES,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const getCoursesBySystemId = (gridData, systemUserId) => {
  return (dispatch) => {
    dispatch(
      custom(
        studentConstants.GET_COURSES_BY_SYSTEM_ID,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    CourseService.getCoursesBySystemId(systemUserId, gridData)
      .then((response) => {
        dispatch(success(response, studentConstants.GET_COURSES_BY_SYSTEM_ID));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            studentConstants.GET_COURSES_BY_SYSTEM_ID,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const getQuestions = () => {
  return (dispatch) => {
    dispatch(
      custom(
        studentConstants.GET_ALL_QUESTIONS,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    CourseService.getQuestions()
      .then((response) => {
        dispatch(success(response, studentConstants.GET_ALL_QUESTIONS));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            studentConstants.GET_ALL_QUESTIONS,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const addFeedback = (data, systemUserId, setShow) => {
  return (dispatch) => {
    dispatch(
      custom(
        studentConstants.GET_PAGINATION_DATA,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    CourseService.addFeedback(data)
      .then((response) => {
        dispatch(getCoursesBySystemId(gridData, systemUserId));
        setShow(false);
        ToastifyService.showSuccess(i18next.t(response));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            studentConstants.GET_PAGINATION_DATA,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const getFeedbackByCourseId = (id) => {
  return (dispatch) => {
    dispatch(
      custom(
        studentConstants.GET_FEEDBACK_BY_ID,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    CourseService.getFeedbackByCourseId(id)
      .then((response) => {
        dispatch(success(response, studentConstants.GET_FEEDBACK_BY_ID));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            studentConstants.GET_FEEDBACK_BY_ID,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const publishOrDisableFeedback = (data) => {
  return (dispatch) => {
    dispatch(
      custom(
        studentConstants.GET_PAGINATION_DATA,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    CourseService.publishOrDisableFeedback(data)
      .then((response) => {
        ToastifyService.showSuccess(i18next.t(response));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            studentConstants.GET_PAGINATION_DATA,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const CourseActions = {
  getStudentsByInstructorId,
  getStatsByInstructorId,
  addStudent,
  getStudentByEmail,
  getStudentById,
  getNonVerifiedStudentById,
  initialState,
  getStudentsByCenterId,
  getAllCourses,
  getCoursesBySystemId,
  getQuestions,
  addFeedback,
  getFeedbackByCourseId,
  publishOrDisableFeedback,
};
